<main class="content">
  <section class="card">
    <h2>Postulaciones asignadas</h2>
    <p class="subtitle">{{ mensaje }}</p>

    <div class="filters-row">
      <select [(ngModel)]="idPostulacionSeleccionado" (change)="aplicarOrden()">
        <option value="Todos">Todos los ID de postulación</option>
        <option *ngFor="let item of idsPostulacion" [value]="item">{{ item }}</option>
      </select>
      <select [(ngModel)]="subdireccionSeleccionada" (change)="aplicarOrden()">
        <option value="Todas">Todas las subdirecciones</option>
        <option *ngFor="let item of subdirecciones" [value]="item">{{ item }}</option>
      </select>
      <select [(ngModel)]="estadoSeleccionado" (change)="aplicarOrden()">
        <option value="Todos">Todos los estados</option>
        <option *ngFor="let item of estados" [value]="item">{{ etiquetaEstado(item) }}</option>
      </select>
    </div>

    <div class="orden-row">
      <label for="ordenCampo">Ordenar por:</label>
      <select id="ordenCampo" [(ngModel)]="ordenarPor" (change)="aplicarOrden()">
        <option value="id_postulacion">ID Postulación</option>
        <option value="avance">Avance</option>
        <option value="concurso">Concurso</option>
        <option value="subdireccion">Subdirección</option>
        <option value="folio">Folio</option>
        <option value="proyecto">Proyecto</option>
        <option value="estado">Estado</option>
      </select>
      <select id="ordenDireccion" [(ngModel)]="ordenDireccion" (change)="aplicarOrden()">
        <option value="desc">Desc</option>
        <option value="asc">Asc</option>
      </select>
    </div>

    <div class="table-wrap" *ngIf="postulacionesOrdenadas.length > 0; else sinResultadosPostulacionesTpl">
      <table class="table">
        <thead>
          <tr>
            <th>ID Postulación</th>
            <th>Concurso</th>
            <th>Subdirección</th>
            <th>Folio</th>
            <th>Proyecto</th>
            <th>Estado</th>
            <th>Avance (%)</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of postulacionesPaginadas">
            <td>{{ item.idPostulacion }}</td>
            <td>{{ item.concurso }}</td>
            <td>{{ item.subdireccion }}</td>
            <td>{{ item.folio }}</td>
            <td>{{ item.nombreProyecto }}</td>
            <td>{{ etiquetaEstado(item.estadoPostulacion) }}</td>
            <td>{{ item.avancePorcentaje ?? 0 }}%</td>
            <td>
              <a
                class="btn-view"
                [routerLink]="['/postulaciones/formulario', item.idPostulacion]"
                [queryParams]="{ role: rol }"
                target="_blank"
                rel="noopener noreferrer"
                title="Ver formulario de postulación"
                aria-label="Ver formulario de postulación"
              >
                Ver formulario
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <ng-template #sinResultadosPostulacionesTpl>
      <app-empty-filter-state title="No se han encontrado postulaciones" message="Ajusta los filtros aplicados o limpia la búsqueda para volver a intentarlo."></app-empty-filter-state>
    </ng-template>

    <app-table-pagination
      [page]="paginaActual"
      [pageSize]="cantidadPorPagina"
      [totalItems]="postulacionesOrdenadas.length"
      itemLabel="postulaciones"
      [pageSizeOptions]="opcionesCantidad"
      (pageChange)="cambiarPagina($event)"
      (pageSizeChange)="cambiarCantidadDesdePaginador($event)"
    ></app-table-pagination>
  </section>
</main>
